<div class="content-cards-time">
  <div class="cardBar">
    <p class="title">Tiempo promedio de respuesta</p>
    <p class="description">
      Tiempo que se tarda en responder a una alerta después de que se haya
      abierto.
    </p>
    <div class="displayFlex">
      <p class="hourCurrent">
        {{ currentMonthAverageResponse?.toFixed(0) }} horas
      </p>
      <p class="hourPrevious">
        {{ previousMonthAverageResponse?.toFixed(0) }} horas
      </p>
    </div>
    <div class="progress-container">
      <div
        class="custom-progress-bar"
        [ngStyle]="{
          background:
            'linear-gradient(to right, #2ec935 ' +
            (currentMonthAverageResponse * 100) /
              (currentMonthAverageResponse + previousMonthAverageResponse || 1) +
            '%, #d8d8d8 ' +
            (currentMonthAverageResponse * 100) /
              (currentMonthAverageResponse + previousMonthAverageResponse || 1) +
            '%)'
        }"
      ></div>
    </div>
    <div class="displayFlex">
      <p class="hourCurrentText">Este mes</p>
      <p class="description">Mes anterior</p>
    </div>
  </div>
</div>

<div class="content-cards-time">
  <div class="cardBar">
    <p class="title">Tiempo promedio de resolución</p>
    <p class="description">
      Tiempo que se tarda en resolver una alerta desde el momento en que se
      abrió.
    </p>
    <div class="displayFlex">
      <p class="hourCurrent">
        {{ currentMonthAverageResolution?.toFixed(0) }} horas
      </p>
      <p class="hourPrevious">
        {{ previousMonthAverageResolution?.toFixed(0) }} horas
      </p>
    </div>
    <div class="progress-container">
      <div
        class="custom-progress-bar"
        [ngStyle]="{
          background:
            'linear-gradient(to right, #a764d7 ' +
            (currentMonthAverageResolution * 100) /
              (currentMonthAverageResolution + previousMonthAverageResolution || 1) +
            '%, #d8d8d8 ' +
            (currentMonthAverageResolution * 100) /
              (currentMonthAverageResolution + previousMonthAverageResolution || 1) +
            '%)'
        }"
      ></div>
    </div>
    <div class="displayFlex">
      <p class="hourCurrentText">Este mes</p>
      <p class="description">Mes anterior</p>
    </div>
  </div>
</div>
